'use client';

import type { JSX } from 'react';
import React from 'react';
import type { ApiSightseeingItem } from '../../../api/model';
import type { EditableAreaOrPageChild } from '@/types/cms/magnolia';
import dynamic from 'next/dynamic';
const SightseeingList = dynamic(() => import('@/components/sightseeing/SightseeingList'));

const SightseeingListWrapper = (
  props: {
    sightseeingItems?: ApiSightseeingItem[];
    theme: string;
  } & Partial<EditableAreaOrPageChild>
): JSX.Element => {
  return <SightseeingList {...props} />;
};

export default SightseeingListWrapper;
